module.exports = __webpack_public_path__ + "static/media/ai.4fb40197.webp";